<template>
    <app-layout title="Data Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc"/>
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion :multiple="true" :activeIndex="[0]">
                                    <AccordionTab :disabled="action == 'create'">
                                        <StatusDokumenPengadaanInfo></StatusDokumenPengadaanInfo>
                                    </AccordionTab>
                                    <AccordionTab :disabled="true">
                                        <template #header>
                                            <span class="flex align-items-center gap-2 w-full">
                                                <span class="font-bold white-space-nowrap">Data Utama</span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            {{ dataViewDokumenPengadaan }}
                                        </div>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_perusahaan"
                                                    value="Nama Perusahaan"
                                                />
                                                <Input
                                                    id="nama_perusahaan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                            </div>

                                        </div>

                                    </AccordionTab>
                                </Accordion>
                            </div>

                        </div>
                    </section>

                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import {defineComponent} from 'vue'
import {ref} from "vue";
import AppLayout from '@/Layouts/AppLayout.vue'
import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import InputError from "@/Components/InputError";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import InputMask from 'primevue/inputmask';
import ButtonSave from "@/Components/ButtonSave";
import ButtonShow from "@/Components/ButtonShow";
import ButtonEdit from "@/Components/ButtonEdit.vue";
import Button from 'primevue/button';
import pdf from "@/Components/Pdf.vue";
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonLinkEdit from "@/Components/ButtonLinkEdit";
import Message from 'primevue/message';
import {Pesan} from "@/constants";
import md5Hex from "md5-hex";


// const visible = ref(false);
export default defineComponent({

    components: {
        AppLayout,
        JetSectionBorder,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        Input,
        InputError,
        ButtonSave,
        InputMask,
        pdf,
        ButtonShow,
        Button,
        Dialog,
        DataTable,
        Column,
        ButtonLinkEdit,
        Message,
        ButtonEdit,
        StatusDokumenPengadaanInfo,

    },
    props: {
        action : String,
        dataViewDokumenPengadaan: Object,
        // dataJadwalPengadaan: [Object, Array],
        // dataFileDokumenPengadaan: [Object, Array],
        // dataFormDokumenPengadaan: [Object, Array],
    },

    mounted() {
        
    },
    data() {
        return {

        };
    },
    methods: {
    }
})
</script>
